// @ts-nocheck
/**
 * Template V2 — dynamic default value contracts.
 *
 * CreationTimeDefault is resolved once at item creation and never persisted on the item record.
 */

/** Resolved once when an item is created; never stored on ItemDefinition. */
export interface CreationTimeDefault {
  readonly kind: 'atCreation';
}

/** Item field keys that accept unix-ms timestamps and may use CreationTimeDefault seeds. */
export type TimestampItemFieldKey = 'procuredAt' | 'loanedAt';

export const TIMESTAMP_ITEM_FIELD_KEYS: readonly TimestampItemFieldKey[] = [
  'procuredAt',
  'loanedAt',
] as const;

export function isTimestampItemFieldKey(key: string): key is TimestampItemFieldKey {
  return (TIMESTAMP_ITEM_FIELD_KEYS as readonly string[]).includes(key);
}

export function isCreationTimeDefault(value: unknown): value is CreationTimeDefault {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as CreationTimeDefault).kind === 'atCreation'
  );
}
